import getScopedAssets from '@/util/scopedAssets';

const ONE_DAY = 24 * 60 * 60 * 1000;
const WARN_DAYS = 30;

function daysUntil(dateStr) {
  return Math.ceil((new Date(dateStr).getTime() - Date.now()) / ONE_DAY);
}

function buildExpirationNotifs(assets) {
  const notifs = [];
  assets.forEach((a) => {
    if (!a.massSubscriptionExpiredAt) return;
    const days = daysUntil(a.massSubscriptionExpiredAt);

    if (days < 0) {
      notifs.push({
        id: `asset-expired-${a.massId}`,
        severity: 'danger',
        title: 'Subscription expired',
        message: `Expired ${Math.abs(days)} day(s) ago.`,
        shipName: a.massName,
        time: a.massSubscriptionExpiredAt,
        massId: a.massId,
      });
    } else if (days <= WARN_DAYS) {
      notifs.push({
        id: `asset-expiring-${a.massId}`,
        severity: 'warning',
        title: 'Subscription expiring soon',
        message: `Expires in ${days} day(s).`,
        shipName: a.massName,
        time: a.massSubscriptionExpiredAt,
        massId: a.massId,
      });
    }
  });
  return notifs.sort((x, y) => new Date(x.time) - new Date(y.time));
}

export default {
  namespaced: true,
  state: {
    items: [],
    loading: false,
  },
  getters: {
    notifications: (state) => state.items,
    unreadCount: (state) => state.items.length,
    loading: (state) => state.loading,
  },
  mutations: {
    SET_ITEMS(state, items) { state.items = items; },
    SET_LOADING(state, v) { state.loading = v; },
  },
  actions: {
    async fetch({ commit }) {
      commit('SET_LOADING', true);
      try {
        const assets = await getScopedAssets();
        commit('SET_ITEMS', buildExpirationNotifs(assets));
      } catch (e) {
        console.error('notification fetch failed:', e);
      } finally {
        commit('SET_LOADING', false);
      }
    },
  },
};
